module.exports = __webpack_public_path__ + "03_glasses_black.69107df5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer4/03_glasses_black.png
// module id = OnvH
// module chunks = 0